window.addEventListener("load", function(){
  var slideIndex = 1;
  showSlides();

  function showSlides() {
    var i;
    var slides = document.getElementsByClassName("auto-slides");

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slideIndex++;
    if (slideIndex > slides.length) {slideIndex = 1}
    slides[slideIndex-1].style.display = "block";
    // sets the slider time
    setTimeout(showSlides, 5000);
  }
});
